const defaultState = {
    messages: {},
    sendingMessages: {},
    subscribedRoomsIds: [],
    loadedRoomsIds: [],
    updatedRoomId: null,
};

export default defaultState;
